<mat-card appearance="outlined" class="empty-table">
  <div class="image-container">
    <img
      class="empty-img"
      src="{{ src ?? '/shared/img/tournaments/history-empty.png' }}"
    />
  </div>
  <div class="text-container">
    <p class="empty-header mat-headline-medium">{{ header }}</p>
    <p
      class="empty-info"
      [innerHTML]="isLoggedIn ? loggedInMessage : loggedOutMessage"
    ></p>
    <div class="try-button-container">
      <button
        *ngIf="!isLoggedIn && showLoginButton"
        mat-flat-button
        color="primary"
        mat-button
        (click)="onLogin($event)"
        data-ga-value="empty-list-login-button"
      >
        Login
      </button>
      <button
        *ngIf="buttonText"
        mat-flat-button
        color="primary"
        mat-button
        (click)="onButtonClicked()"
        data-ga-value="empty-list-action-button"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</mat-card>
